import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProductState } from './product.reducer';

export const selectProductState = createFeatureSelector<ProductState>('productReducer');
export const selectProductListId = createSelector(selectProductState, state => state.selectedProductListId);
export const selectCategoryId = createSelector(selectProductState, state => state.selectedCategoryId);
export const selectSubCategoryId = createSelector(selectProductState, state => state.selectedSubcategoryId);
